import { AnalogInput, RadioSensor, RadioSensor433 } from 'z3k-config';
export const analog_sensors_icons = {
    [AnalogInput.Type.MAGNET]: 'magnet',
    [AnalogInput.Type.MOTION_CONTROLLED]: 'motion',
    [AnalogInput.Type.SMOKE]: 'smoke',
    [AnalogInput.Type.LEAK]: 'leak',
    [AnalogInput.Type.MOTION_UNCONTROLLED]: 'motion',
    [AnalogInput.Type.THERMOSTAT]: 'thermostat',
    [AnalogInput.Type.BOILER_FAILURE_MINUS]: 'failure',
    [AnalogInput.Type.BOILER_FAILURE_PLUS]: 'failure',
    [AnalogInput.Type.IGNITION]: 'ignition',
    [AnalogInput.Type.DISCRETE]: 'discrete',
    [AnalogInput.Type.ALARM_BUTTON]: 'alarm-button',
    [AnalogInput.Type.SPEED_SENSOR]: 'speed',
    [AnalogInput.Type.RPM_SENSOR]: 'rpm',
    [AnalogInput.Type.FUEL_STAT_SENSOR]: 'fuel-stat',
    [AnalogInput.Type.ANALOG_INPUT]: '',
    [AnalogInput.Type.PRESSURE_SENSOR_5]: '',
    [AnalogInput.Type.PRESSURE_SENSOR_12]: '',
    [AnalogInput.Type.PRESSURE_SENSOR_MLD_6]: '',
    [AnalogInput.Type.HUMIDITY_SENSOR]: '',
    [AnalogInput.Type.ANALOG_DISCRETE_SENSOR_NO]: 'relay-no',
    [AnalogInput.Type.ANALOG_DISCRETE_SENSOR_NC]: 'relay-nc',
    [AnalogInput.Type.PRESSURE_SENSOR_MLD_10]: '',
};
export const radio_sensors_icons = {
    [RadioSensor.Type.DEFAULT]: '',
    [RadioSensor.Type.HUMIDITY]: 'humidity',
    [RadioSensor.Type.MOTION]: 'motion',
    [RadioSensor.Type.LEAK]: 'leak',
    [RadioSensor.Type.RADIO_FOB_3_BUTTONS_TYPE]: '',
    [RadioSensor.Type.RADIO_FOB_4_BUTTONS_TYPE]: '',
    [RadioSensor.Type.TEMPERATURE_A]: '',
    [RadioSensor.Type.TEMPERATURE_B]: '',
    [RadioSensor.Type.TEMPERATURE_C]: '',
    [RadioSensor.Type.RADIO_DISPLAY_TEMPERATURE]: '',
    [RadioSensor.Type.RADIO_RELAY]: '',
};
export const radio_sensors_433_icons = {
    [RadioSensor433.Type.MAGNET]: 'magnet',
    [RadioSensor433.Type.MOTION]: 'motion',
    [RadioSensor433.Type.SMOKE]: 'smoke',
    [RadioSensor433.Type.LEAK]: 'leak',
    [RadioSensor433.Type.GAS]: 'gas',
    [RadioSensor433.Type.LIQUD]: 'leak',
};
